import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import Config from 'src/common/Config';

const API_URL = Config.getApiUrl();

type InlineDocumentEditPayload = {
  documentContent: string;
  editRequest: string;
  clientId: string;
};

export function useInlineDocumentEdit(documentId?: string) {
  const { mutateAsync, error, isLoading, reset } = useMutation({
    mutationFn: async (payload: InlineDocumentEditPayload) => {
      if (!documentId) throw new Error('documentId is required');
      const params = new URLSearchParams({
        document_content: payload.documentContent,
        edit_request: payload.editRequest,
        client_id: payload.clientId,
      });

      const response = await fetch(`${API_URL}/documents/${documentId}/inline-edit?${params}`, {
        method: 'POST',
        credentials: 'include',
      });

      if (response.status < 200 || response.status > 299) throw response;

      const data = await response.json();
      return (data.markdown as string)
        .replaceAll('<replacement>', '<suggestion source="inline">')
        .replaceAll('</replacement>', '</suggestion>');
    },
  });

  const inlineEdit = useCallback(
    (payload: InlineDocumentEditPayload) => mutateAsync(payload),
    [mutateAsync],
  );

  return {
    inlineEdit,
    error,
    isLoading,
    reset,
  };
}
